import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { MDBSpinner } from "mdbreact";
import {
  selectRoom,
  changeDirection,
  resetListNode,
  goBackStep,
  getBookingTree
} from "~/store/totalData/actions";
import { get, find, head } from "lodash";
import { ROOM } from "~/utils/constants";
import { getPartnerFromUrl } from "~/utils/func";
import { partnerInfo } from "~/configs/partnerDetails";
const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ChooseRoomAndTimeMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "choose_room_mobile" */ "~/components/desktop/pages/Schedules/ChooseRoom"
    ),
  loading: LoadableLoading
});
const ChooseRoomAndTimeDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "choose_room_desktop" */ "~/components/desktop/pages/Schedules/ChooseRoom"
    ),
  loading: LoadableLoading
});
class ChooseRoom extends Component {
  componentDidMount() {
    const {
      roomList,
      isDirectionBack,
      selectRoom,
      resetListNode,
      getBookingTree
    } = this.props;

    if (roomList.length === 0) {
      const currentPagePartnerId = getPartnerFromUrl(
        this.props.history.location.pathname
      );
      getBookingTree("", currentPagePartnerId);
    }

    resetListNode(ROOM);

    if (roomList.length === 1) {
      if (isDirectionBack) {
        this.methods.handleGoBack();
      } else {
        const room = head(roomList);
        selectRoom(room);
      }
    }
  }

  methods = {
    handleGoBack: () => {
      this.props.goBackStep("room");
    }
  };

  render() {
    const { device, roomList } = this.props;

    if (roomList.length === 0) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }

    return (
      <React.Fragment>
        {device === "mobile" ? (
          <ChooseRoomAndTimeMobile {...this.props} {...this.methods} />
        ) : (
          <ChooseRoomAndTimeDesktop {...this.props} {...this.methods} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    totalData: {
      room: {
        id: idRoom,
        list: roomList,
        subType: subTypeRoom,
        name: roomName
      },
      listNode,
      isDirectionBack,
      partnerId
    }
  } = state;
  return {
    device: type,
    idRoom,
    roomList,
    subTypeRoom,
    roomName,
    listNode,
    isDirectionBack,
    partnerId
  };
};

const ChooseRoomHelmet = withTitle({
  component: ChooseRoom,
  title: `${hospitalName.value} | Chọn phòng khám`
});

export default connect(mapStateToProps, {
  selectRoom,
  changeDirection,
  resetListNode,
  goBackStep,
  getBookingTree
})(ChooseRoomHelmet);
